import { frontendConfig } from '@kiku/config/env/frontend';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorScreen } from '~/components/common/ErrorScreen';
import { useDocumentTitle } from '~/hooks/use-document-title';

export const Route = createFileRoute('/dev/error')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    if (frontendConfig.MODE === 'production') throw notFound();
  },
  component: DevErrorPreviewPage
});

function DevErrorPreviewPage(): React.ReactNode {
  const { t } = useTranslation();
  useDocumentTitle(t('dev.errorPreview'));

  const [resetCount, setResetCount] = useState(0);

  return (
    <div className="bg-background min-h-screen flex items-center justify-center">
      <ErrorScreen
        key={resetCount}
        error={new Error('This is a simulated error for development preview.')}
        reset={() => {
          setResetCount((c) => c + 1);
        }}
      />
    </div>
  );
}
